// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__q6bvQ","inputWrap":"CustomTip_inputWrap__1nZe6"};